import { render, staticRenderFns } from "./NewHousingItems.vue?vue&type=template&id=34737324"
import script from "./NewHousingItems.vue?vue&type=script&lang=js"
export * from "./NewHousingItems.vue?vue&type=script&lang=js"
import style0 from "./NewHousingItems.vue?vue&type=style&index=0&id=34737324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports